import { PosSupervisorLoginService } from './../../@core/services/pos-supervisor-login.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PosListConfig } from '../pos-list/pos-list-config';
import { UserAndSellerShowMode } from './../../@core/constants';
import { Filter } from './../../models/filter';
import { FilterTable } from './../../models/filter-table';
import { EmployeeFilter } from './../../models/filters/employee-filter';
import { UserFilter } from './../../models/filters/user-filter';
import { Paging } from './../../models/page';
import { CustomerTableModel } from './../../models/table-models/customer-table';
import { User } from './../../models/user';
import { ConfigurationService } from './../../services/configuration.service';
import { CustomerService } from './../../services/customer.service';
import { UsersService } from './../../services/users.service';

@Component({
  selector: 'app-pos-user-and-seller-list-modal',
  templateUrl: './pos-user-and-seller-list-modal.component.html',
  styleUrls: ['./pos-user-and-seller-list-modal.component.sass'],
})
export class PosUserAndSellerListModalComponent implements OnInit {
  public mode: UserAndSellerShowMode | undefined;
  public dataSource: Paging<Array<User>> | Paging<Array<CustomerTableModel>> =
    new Paging([]);
  public tableFilters: Array<FilterTable> = [];
  public config: Partial<PosListConfig> = {};
  public needsLogin = false;

  public selectedValue: User | CustomerTableModel | undefined;

  @Output() selectedValueChange = new EventEmitter<
    User | CustomerTableModel | undefined
  >();

  constructor(
    public bsModalRef: BsModalRef,
    private userService: UsersService,
    private configService: ConfigurationService,
    private customerService: CustomerService,
    private supervisorLoginService: PosSupervisorLoginService
  ) { }

  async ngOnInit(): Promise<void> {
    this.tableFilters =
      this.mode === UserAndSellerShowMode.SELLERS
        ? [new FilterTable('text', 'Búsqueda General')]
        : [new FilterTable('textFilter', 'Búsqueda General')];

    this.config =
      this.mode === UserAndSellerShowMode.SELLERS
        ? { title: 'code', description: 'fullName' }
        : { title: 'username', description: 'fullname' };

    this.dataSource =
      this.mode === UserAndSellerShowMode.SELLERS
        ? await this.getEmployeesData({ page: 0, pageSize: 5, value: {} })
        : await this.getUsersData({
          page: 0,
          pageSize: 5,
          value: {
            branchCode:
              this.configService.readSelectedBranchAndSalesOrg().branch.code,
            textFilter: '',
          },
        });
  }

  cancel() {
    this.bsModalRef.hide();
    this.selectedValueChange.complete();
  }

  async getUsersData(params: Filter<UserFilter>): Promise<Paging<Array<User>>> {
    params.value.branchCode =
      this.configService.readSelectedBranchAndSalesOrg().branch.code;

    let result = await this.userService.readUsers(params).toPromise();

    this.dataSource = result.response;

    return this.dataSource;
  }

  async getEmployeesData(
    params: Filter<EmployeeFilter>
  ): Promise<Paging<Array<CustomerTableModel>>> {
    const result = await this.customerService.readEmployees(params).toPromise();

    this.dataSource = result.response;

    return this.dataSource;
  }

  async handleRowClick(
    selectedValue: CustomerTableModel | User
  ): Promise<void> {
    this.selectedValue = selectedValue;
    let canEmitValue = true;

    if (this.needsLogin) {
      let username = this.isCustomer(this.selectedValue)
        ? this.selectedValue.code
        : this.selectedValue.username;

      canEmitValue = await this.supervisorLoginService.showJustForLogin(
        username,
        true
      );
    }

    if (canEmitValue) {
      this.selectedValueChange.emit(this.selectedValue);
      this.selectedValueChange.complete();
      this.bsModalRef.hide();
    }
  }

  isCustomer(value: CustomerTableModel | User): value is CustomerTableModel {
    return (value as CustomerTableModel).fullName !== undefined;
  }
}
